export default __webpack_public_path__ + "static/media/brave_zone_background_l1.bb80aede.jpg";